import React, { useEffect, useState } from "react";
import { ClientListCard } from "../../components/superadmin";
import { NavLink, useSearchParams } from "react-router-dom";
import { handleApi } from "../../utils/authentication";
import { toast } from "react-toastify";
import LoadingSpinner from "../../components/client/LoadingSpinner";

const ClientList = () => {
  const [clientList, setClientList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [search_query, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("active_clients");
  const [page_details, setPageDeatils] = useState({
    current_page: 1,
    last_page: 1,
    active_clients: 0,
    blocked_clients: 0,
  });

  const getClientList = async () => {
    try {
      setLoading(true);
      let method = "POST";
      let headers = {
        // "Content-Type": "application/json"
      };
      let data = new FormData();
      if (search_query != "") {
        data.append("search", search_query);
      }
      data.append("is_active", activeTab === "active_clients" ? 1 : 0);

      let result = await handleApi(`client_list`, method, headers, data);
      if (result?.success) {
        setClientList(result?.data?.client_list);
        setPageDeatils((prev) => {
          return {
            ...prev,
            active_clients: result?.data?.active_clients,
            blocked_clients: result?.data?.blocked_clients,
          };
        });
      } else {
        // toast.error(result?.error?.error_message ? result?.error?.error_message : "Failed to fetch client list", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        // });
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Failed to fetch client list", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getClientList();
  }, [activeTab]);

  useEffect(() => {
    getClientList();
  }, [search_query]);

  return (
    <div className="row   d-flex flex-row   w-100 m-0">
      {/* <div className="row campaign_header_tab d-flex align-items-center mb-3 ">
                <div className="col-lg-10 col-md-12 row ">
                    <div className="col-lg-2 col-md-3 " >
                    <span  onClick={() => setActiveTab('active_clients')}>
                        <p className={`mb-0 ${activeTab === "active_clients" && "campaign_header_tab_active"}`}>Active Clients({clientList?.length>0?clientList?.length:0})</p>
                        {activeTab === "active_clients" &&
                            <div style={{ border: 'solid 1px #7f56d9' }}> </div>}
                    </span>

                    </div>
                    <div className="col-lg-2 col-md-3 ">
                    <span   onClick={() => setActiveTab('blocked_clients')}>
                        <p className={`mb-0 ${activeTab === "blocked_clients" && "campaign_header_tab_active"}`}>Blocked Clients(00)</p>
                        {activeTab === "blocked_clients" &&
                            <div style={{ border: 'solid 1px #7f56d9' }}> </div>}
                    </span>

                    </div>
                 
                 

                </div>
                <div className="col-lg-2 d-flex justify-content-md-end">
                    <NavLink style={{ marginRight: '-7.5vw' }} to="/super_admin/add_client" className="btn btn-md  rounded-pill text-center  btn-primary nav_export_stats_btn">Create Client</NavLink>

                </div>

            </div> */}
      <div className="row campaign_header_tab d-flex align-items-center mb-3">
        <div className="col-lg-10 col-md-12 p-0">
          <div className="d-flex gap-5 py-2">
            <span onClick={() => setActiveTab("active_clients")}>
              <p
                className={`mb-0 ${activeTab === "active_clients" && "campaign_header_tab_active"}`}
              >
                Active Clients ({page_details?.active_clients})
              </p>
            </span>
            <span onClick={() => setActiveTab("blocked_clients")}>
              <p
                className={`mb-0 ${activeTab === "blocked_clients" && "campaign_header_tab_active"}`}
              >
                Blocked Clients ({page_details?.blocked_clients})
              </p>
            </span>
          </div>
        </div>

        <div className="col-lg-2 col-md-12 d-flex justify-content-end p-0">
          <NavLink
            to="/super_admin/add_client"
            className="btn btn-md  rounded-pill text-center  btn-primary nav_export_stats_btn"
          >
            Create Client
          </NavLink>
        </div>
      </div>
      <div className="d-flex justify-content-start pt-0 pb-4">
        <div className="w-50 d-flex flex-column align-items-center gap-2">
          <label htmlFor="" className="w-100 text-dark">
            Search By (Client Name ,Email,Firstname,Lastname){" "}
          </label>
          <input
            type="text"
            value={search_query}
            placeholder="Search..."
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="form-control"
            id="search"
            name="search"
          />
          {/* <button type="button" className='btn btn-primary' onClick={getClientList}>Search</button> */}
        </div>
      </div>

      <div className="card campaign_card position-relative  ">
        <div className="d-flex justify-content-between align-items-center  campaign_card_heading">
          <p className="mb-0">
            {activeTab === "active_clients"
              ? "Active Client List"
              : "Blocked Client List"}
          </p>
        </div>
        {/* client list header */}

        {/* client list */}
        {loading ? (
          <div className="position-absolute top-50 end-50">
            <LoadingSpinner />
          </div>
        ) : (
          clientList?.map((client) => {
            return <ClientListCard client={client} />;
          })
        )}
        {!loading && clientList.length == 0 && (
          <div className="position-absolute top-50  end-50">
            <div>
              <h5>Clients not found</h5>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientList;
